/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['locations', 'items', id], null);